import { convertAndJoinLocalesToJapaneseLabel } from '@/utils/array/locale'

export const ERROR_CODE_FOR_ADMIN: Record<string, string> = {
//   '0008': '入力可能数文字数を超えたもの、もしくは数値単位や通貨単位が選択されていない質問があります。', // 他のエラーコードと重複があるため一旦コメントアウト
  '0027': 'サーベイ情報が見つかりませんでした。一覧画面に戻って再度ご確認ください。',
  '0028': 'サーベイ名の重複がありました。以下言語のサーベイ名をご確認ください。',
  '0031': '質問が1つも登録されていません',
  '0032': '入力がないカテゴリ名が存在します。以下言語のカテゴリ名をご確認ください。',
  '0033': '入力がない中項目が存在します。以下言語の中項目をご確認ください。',
  '0034': '入力がない選択肢が存在します。以下言語の選択肢をご確認ください。',
  '0035': '入力がないラベル名が存在します。以下言語のラベル名をご確認ください。',
  '0036': '入力がない質問文が存在します。以下言語の質問文をご確認ください。',
  'EVALUATION_ESG_TEMPLATE_MISMATCH_EXCEPTION': 'アスエネ調査票の評価テンプレートに、バイヤー独自調査票の回答が含まれています。',
  'EVALUATION_BUYER_TEMPLATE_MISMATCH_EXCEPTION': 'バイヤー独自の評価テンプレートに、アスエネ調査票の回答が含まれています。',
  'TEMPLATE_EVALUATION_CSV_DATA_NOT_FOUND': 'アスエネ評価登録用テンプレートCSVに出力するデータがありません。',
  'TEMPLATE_BUYER_EVALUATION_CSV_DATA_NOT_FOUND': 'バイヤー独自評価登録用テンプレートCSVに出力するデータがありません。',
  'EVALUATION_CSV_DATA_NOT_FOUND': '評価登録するデータが存在しません。',
  'COMBINATION_QUESTION_NOT_CORRECT': '条件分岐質問の組み合わせが不正です。質問がループしないように修正してください。',
  'PHONE_NUMBER_WITH_COUNTRY_CODE_IS_REQUIRED_FOR_COMPANIES_USING_SMS': 'SMS認証を有効にしている会社は、国コードを含む電話番号が必要です。',
  'COMPARISON_IS_WRONG_ANSWER_REQUIRED_TYPE_EXCEPTION': '比較設問は必須回答にしてください。',
  'INVALID_QUESTION_COMPARISON_EXCEPTION': '閾値を設ける設定と比較設問の設定は同時に行えません。',
  'SUPPLIER_BULK_LINK_STATUS_MISMATCH_EXCEPTION': 'ステータスが「調査終了」または「終了済み」の調査票/サーベイには被評価企業を追加できません。',
  'SUPPLIER_BULK_LINK_LIMIT_OVER_EXCEPTION': 'CSVの行数が上限を超えています。',
  'CAN_NOT_UPDATE_BUYER_CREATED_QUESTION_GROUP_EXCEPTION': '自社作成アンケートの登録URLで更新できない項目がありました。',
  'CAN_NOT_REGISTER_EVALUATION_BUYER_CREATED_QUESTION_GROUP_EXCEPTION': 'バイヤーが作成したアンケートに対する評価登録はできません',
  'BUYER_CREATE_QUESTION_GROUP_IS_NOT_ALLOWED_EXCEPTION': '自社作成アンケートに紐づく専用登録URLは新規発行できません。',
  'BUYER_CREATE_QUESTION_GROUP_LINK_IS_NOT_ALLOWED_EXCEPTION': '自社作成アンケートの調査票は直接紐づけることができません。',
  'CAN_NOT_REVERT_BUYER_CREATED_QUESTION_GROUP_EXCEPTION': '自社作成アンケートは一時保存に戻すことができません。',
  'QUESTION_WEIGHT_LIMIT_OVER_EXCEPTION': '配点の合計が100点になるように調整してください。',
  'QUESTION_WEIGHT_STATUS_MISMATCH_EXCEPTION': 'サプライヤーから提出済みの回答がある場合は配点登録ができません。',
  'CANNOT_REGISTER_QUESTION_WEIGHT_FOR_BUYER_CREATED_GROUP_EXCEPTION': '自社作成アンケートには配点を登録できません。',
  'VALIDATION_ERROR': 'ヘッダーに誤りがあります。',
  'QUESTION_WEIGHT_VALIDATION_EXCEPTION': '不正な記述があります。',
} as const satisfies Record<string, string>

export const hasErrorMessageForAdmin = (code: string) => {
  return code in ERROR_CODE_FOR_ADMIN
}

export const getErrorMessageForAdmin = (code: string, message: string) => {
  if (!hasErrorMessageForAdmin(code)) {
    return message
  }
  switch (code) {
    case '0028':
    case '0032':
    case '0033':
    case '0034':
    case '0035':
    case '0036':
      return `${ERROR_CODE_FOR_ADMIN[code]}\n\n${convertAndJoinLocalesToJapaneseLabel(JSON.parse(message))}`
    default:
      return ERROR_CODE_FOR_ADMIN[code]
  }
}
